import request from '../../../shared/request'

export function getDobNotes(job_id) {
  return request(`/job/dob_notes/${job_id}/`)
}

export function createDobNote(payload) {
  return request(`/job/dob_notes/${payload.job_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateDobNote(payload) {
  return request(`/job/dob_notes/${payload.dob_note_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteDobNote(payload) {
  return request(`/job/dob_notes/${payload.dob_note_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/dobNotes.js